import { User } from 'src/admin/users/types';
import { formatName, NameFormat } from 'src/utils/nameFormatting';

export const NO_ADVISOR_FILTER_VALUE = '__no_advisor__';

export function matchesAdvisorFilter(
  advisorUserId: string | null | undefined,
  advisorFilter: string | null,
): boolean {
  if (advisorFilter === null) return true;
  if (advisorFilter === NO_ADVISOR_FILTER_VALUE) return !advisorUserId;
  return advisorUserId === advisorFilter;
}

export function getAdvisorSortValue(
  advisorUserId: string | null | undefined,
  advisorMap: Record<string, User>,
): string {
  if (!advisorUserId) return '';
  const advisor = advisorMap[advisorUserId];
  return advisor ? formatName(advisor.firstName, advisor.lastName) : '';
}

export function matchesAdvisorSearch(
  advisorUserId: string | null | undefined,
  advisorMap: Record<string, User>,
  searchTerm: string,
): boolean {
  if (!advisorUserId) return false;
  const advisor = advisorMap[advisorUserId];
  if (!advisor) return false;
  return formatName(advisor.firstName, advisor.lastName, NameFormat.NATURAL)
    .toLowerCase()
    .includes(searchTerm.toLowerCase());
}
